<div class="container-fluid px-4 py-4">
  <!-- Header Section -->
  <div class="card"> 
    <div class="card-body">
      <div class="header-section mb-2">
      <div class="d-flex align-items-center mb-2">
        <div class="service-icon me-2">
          <i class="fas fa-user-shield text-primary"></i>
        </div>
        <h5 class="fs-6 fw-bold mb-0 text-dark">
          My Applications
        </h5>
      </div>
      <p class="text-xs text-muted mb-0 lh-sm">
        View and manage your assigned workflow applications. Continue pending ones or upload batches for efficient processing.
      </p>
    </div>
        <!-- Applications Table -->
        <CustomTable
          :fetchData="fetchApplications"
          :columns="tableColumns"
          :hasActions="true"
          tableKey="assigned_workflows"
          :showSearch="true"
        >
          <!-- Workflow Name with Icon -->
          <template #cell-workflow_name="{ row }">
            <div class="d-flex align-items-center">
              <div class="service-icon me-2">
                <i class="bi bi-building text-primary"></i>
              </div>
              <div>
                <div class="fw-semibold text-dark">{{ row.workflow_name }}</div>
                <div class="text-muted small">{{ row.company_name }}</div>
              </div>
            </div>
          </template>

          <!-- Status Badge -->
          <template #cell-application_status="{ row }">
            <span class="badge" :class="getStatusBadgeClass(row.application_status)">
              {{ row.application_status }}
            </span>
          </template>

          <!-- Applicant Info -->


          <!-- Created Date -->
          <template #cell-date_created="{ row }">
            <div>{{ formatDate(row.date_created) }}</div>
            <div class="text-muted small">{{ formatRelativeDate(row.date_created) }}</div>
          </template>

          <!-- Actions -->
          <template #actions="{ row }">
            <div class="d-flex gap-2">
              <button 
                class="btn btn-sm btn-bg-green rounded-3 shadow-sm text-xs"
                @click="continueApplication(row.application_id, row.workflow_id)"
                title="Continue Application"
              >
                <i class="bi bi-play-circle me-1"></i>
                Continue
              </button>
              <button 
                v-if="row.allow_batch_onboarding"
                class="btn btn-sm btn-bg-green rounded-3 shadow-sm text-xs"
                @click="open_batch_upload_modal(row.workflow_id, row.workflow_name)"
                title="Upload Batch"
              >
                <i class="bi bi-upload"></i>
              </button>
            </div>
          </template>
        </CustomTable>
  </div>
  </div>
</div>